import { EXTERNAL_TRANSFER_NODE_IDENTIFIER } from '@/modules/estateWaterfall/waterfallGraph/constants';
import { EstateWaterfallTransferKind } from '@/types/schema';
import { EstateWaterfallHypotheticalTransferDestinationKind } from '@/types/schema';
import { EstateWaterfallHypotheticalTransferSourceKind } from '@/types/schema';
import { HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragment } from '@/utils/hypotheticalTransfers/graphql/HypotheticalTransferUtils.generated';

import { createTransferCard } from './TransferCard';
import { CardConfig } from './types';

interface CreateExternalTransferCardsParams {
  source: string;
  target: string;
  sourceEntityName: string;
  targetEntityName: string;
  hypotheticalTransfers: HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragment[];
}

export function createExternalTransferCards({
  source,
  target,
  sourceEntityName,
  targetEntityName,
  hypotheticalTransfers,
}: CreateExternalTransferCardsParams) {
  const toExternalTransfers: HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragment[] =
    [];
  const fromExternalTransfers: HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragment[] =
    [];

  if (source.includes(EXTERNAL_TRANSFER_NODE_IDENTIFIER)) {
    const relevantExternalTransfer = hypotheticalTransfers.filter(
      (transfer) =>
        transfer?.sourceKind ===
        EstateWaterfallHypotheticalTransferSourceKind.External
    );

    if (relevantExternalTransfer.length > 0) {
      relevantExternalTransfer.forEach((transfer) => {
        toExternalTransfers.push(transfer);
      });
    }
  }

  if (target.includes(EXTERNAL_TRANSFER_NODE_IDENTIFIER)) {
    const relevantExternalTransfer = hypotheticalTransfers.filter(
      (transfer) =>
        transfer?.destinationKind ===
        EstateWaterfallHypotheticalTransferDestinationKind.External
    );

    if (relevantExternalTransfer.length > 0) {
      relevantExternalTransfer.forEach((transfer) => {
        fromExternalTransfers.push(transfer);
      });
    }
  }

  const cards: CardConfig[] = [];

  toExternalTransfers.forEach((transfer, idx) => {
    cards.push(
      createTransferCard({
        sourceEntityName,
        targetEntityName,
        transfer: {
          kind: EstateWaterfallTransferKind.HypotheticalValue,
          year: transfer.startYear ?? new Date().getFullYear(),
          isHypothetical: true,
          finalTransferAmount: transfer.transferValue,
          associatedObject: {
            __typename: 'EstateWaterfallHypotheticalTransfer',
            id: `to-external-transfer-${idx}`,
            startYear: transfer.startYear,
            endYear: transfer.endYear,
          },
        },
      })
    );
  });

  fromExternalTransfers.forEach((transfer, idx) => {
    cards.push(
      createTransferCard({
        sourceEntityName,
        targetEntityName,
        transfer: {
          kind: EstateWaterfallTransferKind.HypotheticalValue,
          year: transfer.startYear ?? new Date().getFullYear(),
          isHypothetical: true,
          finalTransferAmount: transfer.transferValue,
          associatedObject: {
            __typename: 'EstateWaterfallHypotheticalTransfer',
            id: `from-external-transfer-${idx}`,
            startYear: transfer.startYear,
            endYear: transfer.endYear,
          },
        },
      })
    );
  });

  return cards;
}
